import { Controller } from "@hotwired/stimulus"

// Bulk takedown on the distribution step: tick platforms, confirm, post.
//
// A generalised copy of dsp_takedown_controller (albums), which builds its URL
// from an album id. This one is told the URL, so it carries no knowledge of
// which kind of release it is acting on.
export default class extends Controller {
  static targets = ["masterCheckbox", "dspCheckbox"]
  static values = { takedownUrl: String, confirm: String, noneSelected: String }

  toggleAll(event) {
    this.dspCheckboxTargets.forEach(checkbox => { checkbox.checked = event.target.checked })
  }

  updateMasterCheckbox() {
    if (!this.hasMasterCheckboxTarget) return

    const checked = this.dspCheckboxTargets.filter(checkbox => checkbox.checked).length

    this.masterCheckboxTarget.checked = checked > 0 && checked === this.dspCheckboxTargets.length
    this.masterCheckboxTarget.indeterminate = checked > 0 && checked < this.dspCheckboxTargets.length
  }

  takedown() {
    // Both layouts render a checkbox per platform, so the same platform can
    // appear twice in the target list - the set collapses that.
    const selected = [ ...new Set(
      this.dspCheckboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.dataset.dspCode)
    ) ]

    if (selected.length === 0) {
      window.alert(this.noneSelectedValue)
      return
    }

    if (!window.confirm(this.confirmValue.replace("%{count}", selected.length))) return

    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.takedownUrlValue

    const token = document.createElement("input")
    token.type = "hidden"
    token.name = "authenticity_token"
    token.value = document.querySelector('meta[name="csrf-token"]').content
    form.appendChild(token)

    const codes = document.createElement("input")
    codes.type = "hidden"
    codes.name = "dsp_codes"
    codes.value = JSON.stringify(selected)
    form.appendChild(codes)

    document.body.appendChild(form)
    form.submit()
  }
}
